<script context="module" lang="ts">
	export const selectableList = [
		{
			case: "TEMP_UNLOCK_TEN_MIN",
			text: "10분간 잠금해제",
		},
		{
			case: "TEMP_UNLOCK_ONE_HR",
			text: "1시간 잠금 해제",
		},
		{
			case: "DISABLE_LOCK",
			text: "잠금 설정해제",
		},
		{
			case: "REJECT",
			text: "잠금 해제 요청 거부",
		},
	];

</script>

<script lang="ts">
	//UI
	import { DefaultRadio } from "@hitit/new_ui";
	//Utils
	//Types
	//Props
	export let value = "";
	//Constants

	//Variables
	//Functions
	//Do

</script>

<div class="container" t-id="selection">
	{#each selectableList as selectable}
		<label class="row" for={selectable.case}>
			<span class="radio">
				<DefaultRadio
					id={selectable.case}
					value={selectable.case}
					bind:group={value} />
			</span>
			<span>{selectable.text}</span>
		</label>
	{/each}
</div>

<style lang="scss">
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;

		.row {
			display: flex;
			gap: 10px;
			font-weight: 550;
			color: #46474b;
			align-items: center;
			&:hover {
				cursor: pointer;
			}
			.radio {
				width: 30px;
				height: 30px;
			}
		}
	}

</style>
